import { z } from 'zod';

const schema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_PUBLIC_MEDIA_URL: z.string().url().optional(),
});

export const env = schema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL ?? 'http://localhost:5080',
  VITE_PUBLIC_MEDIA_URL: import.meta.env.VITE_PUBLIC_MEDIA_URL,
});
